import { html, mount, safeUrl } from '../core/html.js';
import { get, post, session } from '../core/api.js';
import { withBusy, confirmDialog, toast, statusBadge } from '../core/ui.js';
import { fmtDate, rm } from '../core/format.js';
import { t } from '../core/i18n.js';
import { policyDescription } from '../../../shared/i18n/format.js';
import { breakdownRows } from './property.js';
import { navigate } from '../app.js';

export function gatewayName(g) {
  return t(`gateway.${g.name}`) + (g.livemode || g.name === 'SANDBOX' ? '' : ` (${t('gateway.sandbox_suffix')})`);
}

export async function render(main, { id }) {
  const cfg = session.config;
  const { booking: b } = await get(`/api/bookings/${id}`);
  if (!['PENDING_PAYMENT', 'PAYMENT_PROCESSING'].includes(b.status)) { navigate(`/bookings/${id}`, { replace: true }); return; }
  const gateways = cfg.gateways;
  const policy = b.snapshot.cancellation_policy;

  mount(main, html`<div class="wrap" style="max-width:980px;padding-top:20px">
    <a href="#/property/${b.property_id}" class="small">${t('checkout.back')}</a>
    <h1 style="margin-top:8px">${t('checkout.title')}</h1>
    <div class="detail" style="padding-top:8px">
      <div class="stack">
        <div class="panel"><h2>${t('checkout.your_trip')}</h2>
          <div><b>${t('checkout.dates')}</b><div>${fmtDate(b.check_in)} – ${fmtDate(b.check_out)} (${t('common.nights', { n: b.nights })})</div></div>
          <div style="margin-top:10px"><b>${t('booking.guests')}</b><div>${t('common.people', { n: b.guests })}</div></div>
        </div>
        <div class="panel"><h2>${t('checkout.payment_method')}</h2>
          ${gateways.length ? html`<div class="list" role="radiogroup" aria-label="${t('checkout.payment_method')}">${gateways.map((g, i) => html`<label class="item" style="cursor:pointer"><input type="radio" name="gw" value="${g.name}" ${i === 0 || g.name === cfg.default_gateway ? 'checked' : ''}> <span class="grow"><b>${gatewayName(g)}</b><div class="small muted">${g.methods.map((m) => t(`method.${m}`)).join(', ')}</div></span></label>`)}</div>`
          : html`<p class="errtext">${t('checkout.no_gateway')}</p>`}
          <p class="small muted" style="margin-top:10px">${t('checkout.redirect_note')}</p>
        </div>
        <div class="panel"><h2>${t('property.cancellation', { policy: t(`policy.${policy.key}`) })}</h2><p class="muted">${policyDescription(t, policy)}</p></div>
        <div class="row"><button class="btn btn-primary" id="pay" ${gateways.length ? '' : 'disabled'}>${t('checkout.pay', { total: rm(b.fin.guest_total_minor) })}</button><button class="btn btn-ghost" id="cancel">${t('checkout.cancel_booking')}</button></div>
        <p class="small muted" id="hold"></p>
      </div>
      <aside class="bookpanel">
        <div class="row" style="flex-wrap:nowrap">${b.snapshot.property_photo ? html`<img src="${safeUrl(b.snapshot.property_photo)}" alt="" style="width:96px;height:72px;border-radius:10px;object-fit:cover">` : ''}<div><b>${b.snapshot.property_name}</b><div class="small muted">${b.snapshot.host_name}</div></div></div>
        <h3 style="margin-top:14px">${t('checkout.price_details')}</h3>
        ${breakdownRows(b.pricing)}
        <div class="small muted">${t('booking.ref', { id: b.id })} ${statusBadge(b.status, 'booking')}</div>
      </aside>
    </div></div>`);

  const holdEl = main.querySelector('#hold');
  const tick = () => {
    const ms = b.hold_expires_at - Date.now();
    if (ms <= 0) { holdEl.textContent = t('checkout.hold_expired'); main.querySelector('#pay').disabled = true; return; }
    const m = Math.floor(ms / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    holdEl.textContent = t('checkout.hold_left', { time: `${m}:${String(s).padStart(2, '0')}` });
  };
  tick();
  const timer = setInterval(tick, 1000);

  main.querySelector('#pay').onclick = (e) => withBusy(e.currentTarget, async () => {
    const gw = main.querySelector('input[name="gw"]:checked')?.value;
    const p = await post('/api/payments/create', { booking_id: b.id, gateway: gw });
    location.href = safeUrl(p.checkout_url);
  });
  main.querySelector('#cancel').onclick = async () => {
    if (!(await confirmDialog(t('checkout.cancel_title'), t('checkout.cancel_text'), { confirmText: t('checkout.cancel_booking'), danger: true }))) return;
    await post(`/api/bookings/${b.id}/cancel`, {});
    toast(t('booking.cancelled_toast'));
    navigate(`/property/${b.property_id}`);
  };
  return () => clearInterval(timer);
}
